import React from 'react';

export enum AlertVariant {
    confirmation = 'confirmation',
    error = 'error',
    inactive = 'inactive',
    information = 'information',
    warning = 'warning'
}

interface IAlert {
    // attributes
    title?: string;
    analytics?: string;
    contentFocus?: boolean;
    dynamic?: boolean;
    isFullWidth?: boolean;
    variant?: AlertVariant;
    // extra nous
    className?: string;
    dataTestId?: string;
}

export const Alert: React.FC<IAlert> = ({
    // attributes
    title,
    analytics,
    contentFocus,
    dynamic,
    isFullWidth,
    variant,
    className,
    children,
    // extra nous
    dataTestId
}) => (
    // @ts-ignore
    <dsd-alert
        analytics={analytics}
        content-focus={contentFocus}
        dynamic={dynamic}
        full-width={isFullWidth}
        variant={variant}
        class={className}
        data-testid={dataTestId}
    >
        <span slot="title">{title}</span>
        {children}
        {/* @ts-ignore */}
    </dsd-alert>
);
